import { useState } from 'react';
import { MessagesSquare, Plus } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import ThreadCard from '../ThreadCard';
import AddChatModal from '../AddChatModal';
import Loaders from '../Loaders';
import projectService from '../../services/projectService';
import { ResearchProjectStyle } from './ResearchProject.style';

const ResearchProjectBlock = () => {
  const { id } = useParams();
  const [addChatOpen, setAddChatOpen] = useState(false);
  const { fetch, refetch } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
    refetch: v.refetch,
  }));

  const { _data, _loading } = projectService.GetProjectSessions(id, fetch);

  return (
    <ResearchProjectStyle>
      {addChatOpen && <AddChatModal onClose={() => setAddChatOpen(false)} refetch={refetch} />}

      <div className="page-header">
        {!_loading && (
          <>
            <h1>{_data?.project_name}</h1>
            <p>{_data?.description}</p>
          </>
        )}
      </div>

      <div className="section-head">
        <h2>Chat Threads</h2>
        <button type="button" className="add-btn" onClick={() => setAddChatOpen(true)}>
          <Plus size={16} />
          Add Chat
        </button>
      </div>

      {_loading ? (
        <Loaders viewLoader />
      ) : _data?.sessions?.length === 0 ? (
        <div className="empty">
          <MessagesSquare className="empty-icon" size={40} />
          <p>
            Start chatting below to start chatting with this project,
            <br /> or use the plus button to add existing chats to this project.
          </p>
        </div>
      ) : (
        <div className="threads">
          <ThreadCard threadCardsData={_data?.sessions} refetch={refetch} />
        </div>
      )}
    </ResearchProjectStyle>
  );
};

export default ResearchProjectBlock;
